import Header from './component';
import HeaderBooking from './header-booking';

export default Header;
export { HeaderBooking };
